import { gql, useMutation } from '@apollo/client'

export const REMOVE_FEED = gql`
  mutation ($id: String!) {
    removeFeed(id: $id) {
      argument_type
      body
      body_updated_at
      campaign_id
      created_at
      fact_id
      id
      product_id
      properties
      __typename
    }
  }
`

export const useRemoveFeed = () => {
  const [mutate, { data, loading, error }] = useMutation(REMOVE_FEED, {
    update(cache) {
      cache.modify({
        fields: {
          getFeeds() {},
          getFeedsByCampaignId() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
